import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Menu } from 'app/shared/models/Menus/menus';
import { TitleService } from 'app/shared/services/title/title.service';
import { UserService } from 'app/shared/services/user/user.service';

@Component({
  selector: 'app-url',
  templateUrl: './url.component.html',
  styleUrls: ['./url.component.scss']
})
export class UrlComponent implements OnInit {

  menu: Menu;
  url: SafeResourceUrl;

  constructor(
    private userService: UserService,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private titleService: TitleService
  ) { }

  ngOnInit(): void {
    this.titleService.title.next(this.route.snapshot.params.name);
    this.getAllMenu();
  }

  private getAllMenu(): void {
    this.userService.getMenuUser().subscribe(res => {
      this.getSingleMenu(res);
    });
  }

  private getSingleMenu(list: Menu[]): void {
    const menuName = this.route.snapshot.params.name;
    list.forEach(item => {
      if (item.lien === menuName) {
        this.menu = item;
      }
    });
    this.getSafeUrl(this.menu.url);
  }

  getSafeUrl(url: string): SafeResourceUrl {
    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    return this.url;
  }
}
